import containerId from '~/client/layout/BaseLayout/LoyaltyMicroFrontend/constant/containerId';
import useLoyalty from '~/client/layout/BaseLayout/LoyaltyMicroFrontend/hooks/useLoyalty';
import NextLink from '~/client/shared/NextLink';
import useLoyaltyControl from './hooks/useLoyaltyControl';
import LoyaltyControlContainer from './LoyaltyControlContainer';

const LoyaltyControl: FC = () => {
  const { hrefLink } = useLoyaltyControl();
  const { isLoyaltyMicroFrontendEnabled, mountLoyaltyApp } = useLoyalty();

  if (isLoyaltyMicroFrontendEnabled) {
    return <div id={containerId.widget} onClick={mountLoyaltyApp} />;
  }

  return (
    <NextLink href={hrefLink}>
      <LoyaltyControlContainer />
    </NextLink>
  );
};

export default LoyaltyControl;
